import { Outlet } from 'react-router-dom';
import Layout from '../components/Layout';

const AppLayout = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default AppLayout;
